import React from 'react';
import { Navigate } from 'react-router-dom';

import RelatoriosLayout from 'components/Layout/Relatorios';
import RelatorioEmConstrucao from 'components/Relatorios/EmConstrucao';
import RelatoriosHome from 'views/Relatorios';
import DecompView from 'views/Relatorios/Decomp';
import DessemView from 'views/Relatorios/Dessem';
import IntersemanalView from 'views/Relatorios/Intersemanal';
import SemanalView from 'views/Relatorios/Semanal';
import MensalView from 'views/Relatorios/Mensal';
import DessemPremissasGerais from 'components/Relatorios/Dessem/secoes/PremissasGerais';
import PainelAprovacao from 'components/Relatorios/shared/Aprovacao/PainelAprovacao';
import DessemCarga from 'components/Relatorios/Dessem/secoes/Carga';
import DessemCargaLiquida from 'components/Relatorios/Dessem/secoes/CargaLiquida';
import DessemGeracaoRenovavel from 'components/Relatorios/Dessem/secoes/GeracaoRenovavel';
import DessemVisaoGeral from 'components/Relatorios/Dessem/secoes/VisaoGeral';
import DessemResultados from 'components/Relatorios/Dessem/secoes/Resultados';
import VisaoGeral from 'components/Relatorios/Decomp/secoes/VisaoGeral';
import ChuvaObservada from 'components/Relatorios/Decomp/secoes/ChuvaObservada';
import ChuvaPrevista from 'components/Relatorios/Decomp/secoes/ChuvaPrevista';
import Carga from 'components/Relatorios/Decomp/secoes/Carga';
import GeracaoRenovavelUnsi from 'components/Relatorios/Decomp/secoes/GeracaoRenovavelUnsi';
import Resultados from 'components/Relatorios/Decomp/secoes/Resultados';
import EmpilhamentoCustos from 'components/Relatorios/Decomp/secoes/EmpilhamentoCustos';
import PremissasGerais from 'components/Relatorios/Decomp/secoes/PremissasGerais';
import IntersemanalVisaoGeral from 'components/Relatorios/Intersemanal/secoes/VisaoGeral';
import IntersemanalChuvaObservada from 'components/Relatorios/Intersemanal/secoes/ChuvaObservada';
import IntersemanalChuvaPrevista from 'components/Relatorios/Intersemanal/secoes/ChuvaPrevista';
import IntersemanalCarga from 'components/Relatorios/Intersemanal/secoes/Carga';
import IntersemanalResultados from 'components/Relatorios/Intersemanal/secoes/Resultados';
import IntersemanalPremissasGerais from 'components/Relatorios/Intersemanal/secoes/PremissasGerais';
import MatrizChuvaObservada from 'components/Relatorios/Matriz/secoes/ChuvaObservada';
import SemanalVisaoGeral from 'components/Relatorios/Semanal/secoes/VisaoGeral';
import SemanalChuvaObservada from 'components/Relatorios/Semanal/secoes/ChuvaObservada';
import SemanalChuvaPrevista from 'components/Relatorios/Semanal/secoes/ChuvaPrevista';
import SemanalCarga from 'components/Relatorios/Semanal/secoes/Carga';
import SemanalResultados from 'components/Relatorios/Semanal/secoes/Resultados';
import SemanalPremissasGerais from 'components/Relatorios/Semanal/secoes/PremissasGerais';
import MensalVisaoGeral from 'components/Relatorios/Mensal/secoes/VisaoGeral';
import MensalChuvaObservada from 'components/Relatorios/Mensal/secoes/ChuvaObservada';
import MensalChuvaPrevista from 'components/Relatorios/Mensal/secoes/ChuvaPrevista';
import MensalSimilaridadeClimatica from 'components/Relatorios/Mensal/secoes/SimilaridadeClimatica';
import MensalCarga from 'components/Relatorios/Mensal/secoes/Carga';
import MensalResultados from 'components/Relatorios/Mensal/secoes/Resultados';
import MensalPremissasGerais from 'components/Relatorios/Mensal/secoes/PremissasGerais';

/**
 * `/relatorios` mostra a home em cards (um por informe — espelha o padrão do
 * Windx). Cada card leva a um grupo de abas próprio, todos sob o mesmo
 * `RelatoriosLayout` (título + TabbedPage + painel de controle):
 *   - Informe Diário:        decomp, dessem, comparador
 *   - Informe Intersemanal:  intersemanal, intersemanal/comparador
 *   - Informe Semanal:       semanal, semanal/matriz, semanal/comparador
 *   - Informe Mensal:        mensal (8 seções; Capacidade Instalada ainda placeholder,
 *                            sem print de referência do Figma), mensal/comparador
 */
const relatoriosRouter = {
  path: 'relatorios',
  children: [
    { index: true, element: <RelatoriosHome /> },
    {
      element: <RelatoriosLayout />,
      children: [
        {
          path: 'decomp',
          element: <DecompView />,
          children: [
            { index: true, element: <Navigate to="visao-geral" replace /> },
            { path: 'visao-geral', element: <VisaoGeral /> },
            { path: 'chuva-observada', element: <ChuvaObservada /> },
            { path: 'chuva-prevista', element: <ChuvaPrevista /> },
            { path: 'carga', element: <Carga /> },
            { path: 'geracao-renovavel-unsi', element: <GeracaoRenovavelUnsi /> },
            { path: 'resultados', element: <Resultados /> },
            { path: 'empilhamento-custos', element: <EmpilhamentoCustos /> },
            { path: 'premissas-gerais', element: <PremissasGerais /> },
            { path: 'aprovacao', element: <PainelAprovacao /> },
            { path: '*', element: <Navigate to="visao-geral" replace /> },
          ],
        },
        {
          path: 'dessem',
          element: <DessemView />,
          children: [
            // Seções placeholder até o Plano 2 (Premissas Gerais vira real na Task 5).
            { index: true, element: <Navigate to="visao-geral" replace /> },
            { path: 'visao-geral', element: <DessemVisaoGeral /> },
            { path: 'carga', element: <DessemCarga /> },
            { path: 'carga-liquida', element: <DessemCargaLiquida /> },
            { path: 'geracao-renovavel', element: <DessemGeracaoRenovavel /> },
            { path: 'resultados', element: <DessemResultados /> },
            { path: 'premissas-gerais', element: <DessemPremissasGerais /> },
            { path: 'aprovacao', element: <PainelAprovacao /> },
            { path: '*', element: <Navigate to="visao-geral" replace /> },
          ],
        },
        { path: 'comparador', element: <RelatorioEmConstrucao titulo="Comparador" /> },
        {
          path: 'intersemanal',
          element: <IntersemanalView />,
          children: [
            { index: true, element: <Navigate to="visao-geral" replace /> },
            { path: 'visao-geral', element: <IntersemanalVisaoGeral /> },
            { path: 'chuva-observada', element: <IntersemanalChuvaObservada /> },
            { path: 'chuva-prevista', element: <IntersemanalChuvaPrevista /> },
            { path: 'carga', element: <IntersemanalCarga /> },
            { path: 'resultados', element: <IntersemanalResultados /> },
            { path: 'premissas-gerais', element: <IntersemanalPremissasGerais /> },
            { path: 'aprovacao', element: <PainelAprovacao /> },
            { path: '*', element: <Navigate to="visao-geral" replace /> },
          ],
        },
        { path: 'intersemanal/comparador', element: <RelatorioEmConstrucao titulo="Comparador" /> },
        {
          path: 'semanal',
          element: <SemanalView />,
          children: [
            { index: true, element: <Navigate to="visao-geral" replace /> },
            { path: 'visao-geral', element: <SemanalVisaoGeral /> },
            { path: 'chuva-observada', element: <SemanalChuvaObservada /> },
            { path: 'chuva-prevista', element: <SemanalChuvaPrevista /> },
            { path: 'carga', element: <SemanalCarga /> },
            { path: 'resultados', element: <SemanalResultados /> },
            { path: 'premissas-gerais', element: <SemanalPremissasGerais /> },
            { path: 'aprovacao', element: <PainelAprovacao /> },
            { path: '*', element: <Navigate to="visao-geral" replace /> },
          ],
        },
        { path: 'semanal/matriz', element: <MatrizChuvaObservada /> },
        { path: 'semanal/comparador', element: <RelatorioEmConstrucao titulo="Comparador" /> },
        {
          path: 'mensal',
          element: <MensalView />,
          children: [
            { index: true, element: <Navigate to="visao-geral" replace /> },
            { path: 'visao-geral', element: <MensalVisaoGeral /> },
            { path: 'chuva-observada', element: <MensalChuvaObservada /> },
            { path: 'chuva-prevista', element: <MensalChuvaPrevista /> },
            { path: 'similaridade-climatica', element: <MensalSimilaridadeClimatica /> },
            { path: 'carga', element: <MensalCarga /> },
            // Sem print de referência do Figma (pendência real, ver
            // docs/2026/relatorios-mensal-STATUS.md).
            {
              path: 'capacidade-instalada',
              element: <RelatorioEmConstrucao titulo="Capacidade Instalada" />,
            },
            { path: 'resultados', element: <MensalResultados /> },
            { path: 'premissas-gerais', element: <MensalPremissasGerais /> },
            { path: 'aprovacao', element: <PainelAprovacao /> },
            { path: '*', element: <Navigate to="visao-geral" replace /> },
          ],
        },
        { path: 'mensal/comparador', element: <RelatorioEmConstrucao titulo="Comparador" /> },
      ],
    },
  ],
};

export default relatoriosRouter;
